"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = __importDefault(require("../icons"));
var react_i18next_1 = require("react-i18next");
var UnderConstruction = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        } },
        react_1.default.createElement(icons_1.default, { className: "icon_blue", height: 300, name: "tool", width: 300 }),
        react_1.default.createElement("p", { style: { fontSize: 50 } }, t("page_under_contruction"))));
};
exports.default = UnderConstruction;
